import React from 'react';
import ReactMarkdown from 'react-markdown';
import markdownComponents from '../utils/markdownComponents';

class MarkdownErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Keep this silent in production; fallback rendering prevents white-screen.
    // eslint-disable-next-line no-console
    console.warn('Markdown render error:', error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

const SafeMarkdown = ({ text }) => {
  const markdownText = typeof text === 'string' ? text : '';

  const fallback = (
    <div className="whitespace-pre-wrap break-words text-sm text-gray-700">
      {markdownText}
    </div>
  );

  return (
    <MarkdownErrorBoundary fallback={fallback}>
      <ReactMarkdown components={markdownComponents}>{markdownText}</ReactMarkdown>
    </MarkdownErrorBoundary>
  );
};

export default SafeMarkdown;
